<template>
    <div class="equipment-warning">
      <!-- 设备选择器 -->
      <div class="device-selector">
        <span class="selector-label">查看其他设备预警情况：</span>
        <el-select v-model="selectedDevice" 
                   placeholder="请选择设备" 
                   @change="handleDeviceChange"
                   class="device-select">
          <el-option v-for="device in allDevicesData"
                     :key="device.devid"
                     :label="device.devidName"
                     :value="device.devid">
          </el-option>
        </el-select>
      </div>
  
      <div class="warning-header">
         <!-- 开盖预警模块 -->
         <div class="warning-module"
             :class="{ 'warning-active': hasCapWarning && !warningAcknowledged }"
             @click="showCapWarningDialog">
          <img v-if="hasCapWarning && !warningAcknowledged"
               src="@/assets/icons/high-temp-active.png"
               class="warning-icon"
               alt="开盖预警" />
          <img v-else
               src="@/assets/icons/high-temp.png"
               class="warning-icon"
               alt="开盖预警" />
          <span>开盖预警</span>
        </div>
        <!-- 激光仓温度预警模块 -->
        <div class="warning-module"
             :class="{ 'warning-active': hasLaserTempWarning && !warningAcknowledged }"
             @click="showLaserTempWarningDialog">
          <img v-if="hasLaserTempWarning && !warningAcknowledged"
               src="@/assets/icons/high-temp-active.png"
               class="warning-icon"
               alt="激光仓温度预警" />
          <img v-else
               src="@/assets/icons/high-temp.png"
               class="warning-icon"
               alt="激光仓温度预警" />
          <span>激光仓温度预警</span>
        </div>
        <!-- 高温预警模块 -->
        <div class="warning-module" 
             :class="{ 'warning-active': hasFireWarning && !warningAcknowledged, 'selected': warningType === 'fire' }"
             @click="showWarningDetails('fire')">
          <img v-if="hasFireWarning && !warningAcknowledged || warningType === 'fire'" 
               src="@/assets/icons/high-temp-active.png" 
               class="warning-icon" 
               alt="高温预警" />
          <img v-else 
               src="@/assets/icons/high-temp.png" 
               class="warning-icon" 
               alt="高温预警" />
          <span>高温预警</span>
          <span class="warning-count" v-if="selectedDeviceData">
            {{ selectedDeviceData.fireAlarmNum }}次
          </span>
        </div>
  
       
  
        <!-- 水箱预警模块 -->
        <div class="warning-module" 
             :class="{ 'warning-active': hasWaterLevelWarning && !warningAcknowledged, 'selected': warningType === 'waterLevel' }"
             @click="showWarningDetails('waterLevel')">
          <img v-if="hasWaterLevelWarning && !warningAcknowledged || warningType === 'waterLevel'" 
               src="@/assets/icons/water-box-active.png" 
               class="warning-icon" 
               alt="水箱预警" />
          <img v-else 
               src="@/assets/icons/water-box.png" 
               class="warning-icon" 
               alt="水箱预警" />
          <span>水箱预警</span>
          <span class="warning-count" v-if="selectedDeviceData">
            {{ selectedDeviceData.waterNum }}次
          </span>
        </div>
  
        
  
        <!-- 水温预警模块 -->
        <div class="warning-module" 
             :class="{ 'warning-active': hasWaterTempWarning && !warningAcknowledged, 'selected': warningType === 'waterTemp' }"
             @click="showWarningDetails('waterTemp')">
          <img v-if="hasWaterTempWarning && !warningAcknowledged || warningType === 'waterTemp'" 
               src="@/assets/icons/water-temp-active.png" 
               class="warning-icon" 
               alt="水温预警" />
          <img v-else 
               src="@/assets/icons/water-temp.png" 
               class="warning-icon" 
               alt="水温预警" />
          <span>水温预警</span>
          <span class="warning-count" v-if="selectedDeviceData">
            {{ selectedDeviceData.waterTemperatureAlarmNum }}次
          </span>
        </div>
      </div>
  
      <!-- 预警详情表格 -->
      <div v-if="['fire','waterLevel','waterTemp'].includes(warningType) && currentWarningData.length" class="warning-table">
        <div class="table-title">{{ tableTitle }}</div>
        <el-table :data="currentWarningData" border>
          <el-table-column prop="devidName" label="设备名称" width="120"></el-table-column>
          <el-table-column prop="devid" label="设备编号" width="180"></el-table-column>
          <el-table-column prop="warningCount" :label="warningCountLabel" width="120"></el-table-column>
          <el-table-column prop="status" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === '异常' ? 'danger' : 'success'">
    {{ scope.row.status }}
  </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="time" label="更新时间"></el-table-column>
        </el-table>
      </div>
  
      <!-- 异常设备提示对话框 -->
      <el-dialog
        title="设备异常警告"
        :visible.sync="dialogVisible"
        width="50%"
        @close="handleDialogClose">
        <div v-if="abnormalDevices.length > 0">
          <h3>以下设备出现异常：</h3>
          <el-card v-for="device in abnormalDevices" 
                  :key="device.devid" 
                  class="warning-card"
                  :class="getWarningClass(device)">
            <div class="warning-card-content">
              <h4>{{ device.devidName }} ({{ device.devid }})</h4>
              <ul>
                <li v-if="device.fire === 0" class="warning-item">
                  <img src="@/assets/icons/high-temp-active.png" class="warning-icon-small" alt="高温预警" /> 高温异常
                  <span class="warning-count">(已报警 {{ device.fireAlarmNum }} 次)</span>
                </li>
                <li v-if="device.cap === 0" class="warning-item">
                  <img src="@/assets/icons/high-temp-active.png" class="warning-icon-small" alt="开盖预警" /> 开盖异常
                  <span class="warning-count">(已报警 {{ device.capAlarmNum || 0 }} 次)</span>
                </li>
                <li v-if="device.waterLevel === 0" class="warning-item">
                  <img src="@/assets/icons/water-box-active.png" class="warning-icon-small" alt="水箱预警" /> 水位异常
                  <span class="warning-count">(已报警 {{ device.waterNum }} 次)</span>
                </li>
                <li v-if="device.waterTemperatureAlarm === 0" class="warning-item">
                  <img src="@/assets/icons/water-temp-active.png" class="warning-icon-small" alt="水温预警" /> 水温异常
                  <span class="warning-count">(已报警 {{ device.waterTemperatureAlarmNum }} 次)</span>
                </li>
              </ul>
              <div class="warning-time">
                最后更新时间: {{ new Date(device.createTime).toLocaleString() }}
              </div>
            </div>
          </el-card>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="handleDialogClose">我知道了</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import { EventBus } from '@/utils/eventBus'
  
  export default {
    name: 'EquipmentWarning',
    props: {
      institutionName: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        hasFireWarning: false,
        hasWaterLevelWarning: false,
        hasWaterTempWarning: false,
        hasCapWarning: false,
        hasLaserTempWarning: false,
        tableTitle: '高温预警详情',
        warningCountLabel: '预警次数',
        currentWarningData: [],
        warningType: 'fire',
        allDevicesData: [],
        selectedDevice: '',
        selectedDeviceData: null,
        dialogVisible: false,
        warningAcknowledged: false, // 弹窗确认状态
        abnormalDevices: [],
        lastWarningKey: '' // 用于记录上次弹窗的异常设备key
      }
    },
    mounted() {
      // 读取本地持久化的弹窗确认信息
      this.lastWarningKey = localStorage.getItem('lastWarningKey') || '';
      this.warningAcknowledged = localStorage.getItem('warningAcknowledged') === '1';
    },
    created() {
      EventBus.$on('deviceDataUpdated', this.handleDeviceDataUpdate);
      EventBus.$emit('requestDeviceData', this.institutionName); // 主动请求一次设备数据
      // 监听重置确认状态的事件
      EventBus.$on('resetWarningAcknowledge', () => {
        console.log('重置确认状态');
        this.warningAcknowledged = false;
        // 如果有异常设备，立即显示弹窗
        if (this.abnormalDevices.length > 0) {
          console.log('显示弹窗 - 重置触发');
          this.$nextTick(() => {
            this.dialogVisible = true;
          });
        }
      });
    },
    beforeDestroy() {
      EventBus.$off('deviceDataUpdated', this.handleDeviceDataUpdate);
      EventBus.$off('resetWarningAcknowledge');
    },
    methods: {
      handleResetWarning() {
        this.warningAcknowledged = false;
        // 如果有异常设备，立即显示弹窗
        if (this.abnormalDevices.length > 0) {
          this.dialogVisible = true;
        }
      },
      handleDeviceDataUpdate(devices) {
        // 保证设备有 devidName 字段，否则用 devid 兜底
        devices.forEach(d => { d.devidName = d.devidName || d.devid });
        this.allDevicesData = devices;
        // 每次切换机构都重置选中设备为新机构的第一个设备
        if (this.allDevicesData.length > 0) {
          this.selectedDevice = this.allDevicesData[0].devid;
          this.selectedDeviceData = this.allDevicesData[0];
        } else {
          this.selectedDevice = '';
          this.selectedDeviceData = null;
        }
        this.checkWarnings();
        this.updateWarningDetails();
        // 找出所有异常设备
        this.abnormalDevices = this.allDevicesData.filter(device =>
          device.fire === 0 ||
          device.cap === 0 ||
          device.waterLevel === 0 ||
          device.waterTemperatureAlarm === 0
        );
        // 生成异常设备的唯一key（可以用异常设备id和数量拼接）
        const currentWarningKey = this.abnormalDevices.map(d => d.devid).join(',') + ':' + this.abnormalDevices.length;
        const lastWarningKey = localStorage.getItem('lastWarningKey') || '';
        // 如果有新的异常设备出现，重置确认状态（全局一次）
        if (this.abnormalDevices.length > 0 && currentWarningKey !== lastWarningKey) {
          localStorage.setItem('warningAcknowledged', '0');
        }
        // 控制弹窗显示
        if (this.abnormalDevices.length > 0 && !this.warningAcknowledged && this.$route.path.includes('EquipmentWarning')) {
          this.$nextTick(() => {
            this.dialogVisible = true;
          });
        }
        // 记录当前异常设备key
        localStorage.setItem('lastWarningKey', currentWarningKey);
      },
      handleDeviceChange(deviceId) {
        this.selectedDeviceData = this.allDevicesData.find(device => device.devid === deviceId);
        this.checkWarnings();
        this.updateWarningDetails();
      },
      checkWarnings() {
        if (this.selectedDeviceData) {
          // 只检查选中设备的预警状态
          this.hasFireWarning = this.selectedDeviceData.fire === 0;
          this.hasWaterLevelWarning = this.selectedDeviceData.waterLevel === 0;
          this.hasWaterTempWarning = this.selectedDeviceData.waterTemperatureAlarm === 0;
          this.hasCapWarning = this.selectedDeviceData.cap === 0;
          this.hasLaserTempWarning = this.selectedDeviceData.fire === 0;
        } else {
          // 检查所有设备的预警状态
          this.hasFireWarning = this.allDevicesData.some(device => device.fire === 0);
          this.hasWaterLevelWarning = this.allDevicesData.some(device => device.waterLevel === 0);
          this.hasWaterTempWarning = this.allDevicesData.some(device => device.waterTemperatureAlarm === 0);
          this.hasCapWarning = this.allDevicesData.some(device => device.cap === 0);
          this.hasLaserTempWarning = this.allDevicesData.some(device => device.fire === 0);
        }
      },
      showWarningDetails(type) {
        if (["cap", "laserTemp"].includes(type)) return; // 不切换到表格
        this.warningType = type;
        this.updateWarningDetails();
      },
      showCapWarningDialog() {
        if (this.hasCapWarning) {
          this.dialogVisible = true;
        }
      },
      showLaserTempWarningDialog() {
        if (this.hasLaserTempWarning) {
          this.dialogVisible = true;
        }
      },
      updateWarningDetails() {
        let data = this.selectedDevice ? [this.selectedDeviceData] : this.allDevicesData;
        
        switch (this.warningType) {
          case 'fire':
            this.tableTitle = '高温预警详情';
            this.warningCountLabel = '高温预警次数';
            this.currentWarningData = data.map(device => ({
              devidName: device.devidName,
              devid: device.devid,
              warningCount: device.fireAlarmNum,
              status: device.fire === 0 ? '异常' : '正常',
              time: new Date(device.createTime).toLocaleString()
            }));
            break;
          case 'waterLevel':
            this.tableTitle = '水位预警详情';
            this.warningCountLabel = '水位预警次数';
            this.currentWarningData = data.map(device => ({
              devidName: device.devidName,
              devid: device.devid,
              warningCount: device.waterNum,
              status: device.waterLevel === 0 ? '异常' : '正常',
              time: new Date(device.createTime).toLocaleString()
            }));
            break;
          case 'cap':
            this.tableTitle = '开盖预警详情';
            this.warningCountLabel = '开盖预警次数';
            this.currentWarningData = data.map(device => ({
              devidName: device.devidName,
              devid: device.devid,
              warningCount: device.capAlarmNum || 0,
              status: device.cap === 0 ? '异常' : '正常',
              time: new Date(device.createTime).toLocaleString()
            }));
            break;
          case 'laserTemp':
            this.tableTitle = '激光仓温度预警详情';
            this.warningCountLabel = '激光仓温度预警次数';
            this.currentWarningData = data.map(device => ({
              devidName: device.devidName,
              devid: device.devid,
              warningCount: device.fireAlarmNum,
              status: device.fire === 0 ? '异常' : '正常',
              time: new Date(device.createTime).toLocaleString()
            }));
            break;
          case 'waterTemp':
            this.tableTitle = '水温预警详情';
            this.warningCountLabel = '水温预警次数';
            this.currentWarningData = data.map(device => ({
              devidName: device.devidName,
              devid: device.devid,
              warningCount: device.waterTemperatureAlarmNum,
              status: device.waterTemperatureAlarm === 0 ? '异常' : '正常',
              time: new Date(device.createTime).toLocaleString()
            }));
            break;
        }
      },
      handleDialogClose() {
        this.dialogVisible = false;
        this.warningAcknowledged = true;
        localStorage.setItem('warningAcknowledged', '1');
        // 通知index.vue停止闪烁
        EventBus.$emit('warningAcknowledged');
      },
      getWarningClass(device) {
        const warnings = [];
        if (device.fire === 0) warnings.push('fire');
        if (device.waterLevel === 0) warnings.push('water-level');
        if (device.waterTemperatureAlarm === 0) warnings.push('water-temp');
        if (device.cap === 0) warnings.push('cap');
        return warnings;
      }
    }
  }
  </script>
  
  <style scoped>
  .equipment-warning {
    padding: 20px;
    background-color: #fff;
    border-radius:20px ;
  }
  
  .device-selector {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
  }
  
  .selector-label {
    margin-right: 10px;
    font-size: 20px;
    color: #67C23A;
  }
  
  .device-select {
    width: 200px;
    border: 1px solid #67C23A;
  }
  
  .warning-header {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }
  
  .warning-module {
    width: 180px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 15px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
    border: 1px solid #67C23A;
    color: #67C23A;
    position: relative;
  }
  
  .warning-icon {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
  
  .warning-module span {
    color: #67C23A;
  }
  
  .warning-module.warning-active {
    background-color: #67C23A;
    color: white;
    border-color: #67C23A;
  }
  
  .warning-module.warning-active span {
    color: white;
  }
  
  .warning-module.selected {
    background-color: #67C23A;
    color: white;
    border-color: #67C23A;
  }
  
  .warning-module.selected span {
    color: white;
  }
  
  .warning-count {
    margin-left: 5px;
    font-weight: bold;
  }
  
  .warning-table {
    background-color: #fff;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  }
  
  .table-title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #303133;
  }
  
  .warning-card {
    margin-bottom: 15px;
    border-left: 4px solid #F56C6C;
  }
  
  .warning-card-content {
    padding: 10px;
  }
  
  .warning-card h4 {
    margin: 0 0 10px 0;
    color: #303133;
  }
  
  .warning-item {
    color: #F56C6C;
    margin: 5px 0;
    list-style: none;
  }
  
  .warning-icon-small {
    width: 15px;
    height: 15px;
    margin-right: 5px;
  }
  
  .warning-item i {
    margin-right: 5px;
  }
  
  .warning-count {
    color: #909399;
    font-size: 0.9em;
    margin-left: 5px;
  }
  
  .warning-time {
    margin-top: 10px;
    color: #909399;
    font-size: 0.9em;
  }
  
  .fire { border-left-color: #F56C6C; }
  .water-level { border-left-color: #E6A23C; }
  .water-temp { border-left-color: #409EFF; }
  .cap { border-left-color: #67C23A; }
  </style>